import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoutes = () => {
  const authToken = useSelector((state) => state.authentication.authToken);
  // console.log(authToken, "token");

  return authToken ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
